import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    businessList: localStorage.getItem('businessList')? JSON.parse(localStorage.getItem('businessList')) : [],
    selectedBusiness: localStorage.getItem('selectedBusiness')? JSON.parse(localStorage.getItem('selectedBusiness')) : null,
};

export const businessSlice = createSlice({
    name: 'business',
    initialState,
    reducers: {
        setBusinessList: (state, action) => {
            localStorage.setItem('businessList', JSON.stringify(action.payload));
            state.businessList = action.payload;
        },
        setSelectedBusiness: (state, action) => {
            localStorage.setItem('selectedBusiness', JSON.stringify(action.payload));
            state.selectedBusiness = action.payload;
        }
    }
});

export const { setBusinessList, setSelectedBusiness } = businessSlice.actions;
export default businessSlice.reducer;